export default "//static.tradera.net/touchweb/static/output/images/app-store-badge-de.52cafd71.svg";